// UI-chrome localization (buttons/labels/headers/placeholders/status
// messages) — deliberately separate from answer-content language, which is
// handled entirely server-side (the LLM is instructed to answer in the
// question's own language) and rendered with per-element dir="auto" bidi in
// MarkdownView.jsx. This only controls the static strings around that
// content. Manual switcher (see LanguageSwitcher.jsx), not tied to the
// selected workspace — see .claude/plans/kindly-analyze-the-pdf-curried-
// whistle.md for why.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import de from "./locales/de.json";
import ar from "./locales/ar.json";

export const SUPPORTED_LANGUAGES = ["en", "de", "ar"];
export const RTL_LANGUAGES = ["ar"];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, de: { translation: de }, ar: { translation: ar } },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      // localStorage first (the switcher writes here), then browser language,
      // falling back to fallbackLng if neither matches a supported language.
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "uiLanguage",
    },
  });

export function applyDocumentDirection(lng) {
  document.documentElement.lang = lng;
  document.documentElement.dir = RTL_LANGUAGES.includes(lng) ? "rtl" : "ltr";
}

// Cover the initial load (detector may resolve after this module evaluates)
// in addition to every subsequent manual switch (see LanguageSwitcher.jsx).
i18n.on("languageChanged", applyDocumentDirection);
applyDocumentDirection(i18n.resolvedLanguage || i18n.language);

export default i18n;
